import script from "./ChatBubble.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatBubble.vue?vue&type=script&setup=true&lang=js"

import "./ChatBubble.vue?vue&type=style&index=0&id=7c280e0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c280e0a"]])

export default __exports__